import useGameState from '../../hooks/useGameState'
import { useGameContext } from '../../GameContext'
import { useBotOpponent } from '../../bot/botOpponent'
import BattleScreen from './BattleScreen'

// ─── GameBoardV2 ──────────────────────────────────────────────────────────────
//
// Thin shell: wires the useGameState hook to the V2 BattleScreen UI.
// All Firebase sync, action dispatching, and animation logic lives in the hook.
//
export default function GameBoardV2() {
    const {
        selfBoard,
        oppBoard,
        selfScore,
        oppScore,
        currentRound,
        isPaired,
        canDeploy,
        armiesToDeploy,
        oppArmiesToDeploy,
        isSubmitDisabled,
        message,
        setMessage,
        onAction,
        handleSubmit,
        handleReveal,
        isAnimating,
        showingPreResolution,
        activeClashId,
        clashResult,
        activeClashContext,
        activeClashWinner,
        activeClashSelfStrength,
        activeClashOppStrength,
        activeClashOppTargetIndex,
        activeClashSelfTargetIndex,
        activeClashAbsorbed,
        activeClashAimS,
        activeClashSelfHitInfo,
        activeClashSelfHitsLog,
        warResult,
        targetPlots,
        targetSubplots,
        onTargetPlot,
        yieldBalance,
        onHomefrontAction,
        pendingRockets,
        canAffordRocket,
        pendingDrones,
        canAffordDrone,
        onDroneTarget,
        droneFlights,
        baseBuildFx,
        selfHf,
        oppHf,
        selfLost,
        oppLost,
        onStructureKilled,
        structuresToWin,
        warCapacities,
        dropZones,
        requiredDropZoneCount,
        onDropZone,
        placingDropZones,
        resupplyDeliveries,
        revealOverlayUp,
        oppReadyOverlayUp,
    } = useGameState()
    // In a war against the bot, this browser also plays the bot's turns —
    // each once this player has revealed the round before it.
    const { game } = useGameContext()
    useBotOpponent(game, { hold: showingPreResolution || isAnimating })

    return (
        <>
            <BattleScreen
                selfBoard={selfBoard}
                oppBoard={oppBoard}
                selfScore={selfScore}
                oppScore={oppScore}
                currentRound={currentRound}
                isPaired={isPaired}
                canDeploy={canDeploy}
                armiesToDeploy={armiesToDeploy}
                oppArmiesToDeploy={oppArmiesToDeploy}
                isSubmitDisabled={isSubmitDisabled}
                message={message}
                setMessage={setMessage}
                onAction={onAction}
                onSubmit={handleSubmit}
                onReveal={handleReveal}
                isAnimating={isAnimating}
                showingPreResolution={showingPreResolution}
                activeClashId={activeClashId}
                clashResult={clashResult}
                activeClashContext={activeClashContext}
                activeClashWinner={activeClashWinner}
                activeClashSelfStrength={activeClashSelfStrength}
                activeClashOppStrength={activeClashOppStrength}
                activeClashOppTargetIndex={activeClashOppTargetIndex}
                activeClashSelfTargetIndex={activeClashSelfTargetIndex}
                activeClashAbsorbed={activeClashAbsorbed}
                activeClashAimS={activeClashAimS}
                activeClashSelfHitInfo={activeClashSelfHitInfo}
                activeClashSelfHitsLog={activeClashSelfHitsLog}
                warResult={warResult}
                targetPlots={targetPlots}
                targetSubplots={targetSubplots}
                onTargetPlot={onTargetPlot}
                yieldBalance={yieldBalance}
                onHomefrontAction={onHomefrontAction}
                pendingRockets={pendingRockets}
                canAffordRocket={canAffordRocket}
                pendingDrones={pendingDrones}
                canAffordDrone={canAffordDrone}
                onDroneTarget={onDroneTarget}
                droneFlights={droneFlights}
                baseBuildFx={baseBuildFx}
                selfHf={selfHf}
                oppHf={oppHf}
                selfLost={selfLost}
                oppLost={oppLost}
                onStructureKilled={onStructureKilled}
                structuresToWin={structuresToWin}
                warCapacities={warCapacities}
                dropZones={dropZones}
                requiredDropZoneCount={requiredDropZoneCount}
                onDropZone={onDropZone}
                placingDropZones={placingDropZones}
                resupplyDeliveries={resupplyDeliveries}
                revealOverlayUp={revealOverlayUp}
                oppReadyOverlayUp={oppReadyOverlayUp}
            />

        </>
    )
}
